import { render, staticRenderFns } from "./MbInitiateProcessDefault.vue?vue&type=template&id=0a3ce90e&scoped=true"
import script from "./MbInitiateProcessDefault.vue?vue&type=script&lang=js"
export * from "./MbInitiateProcessDefault.vue?vue&type=script&lang=js"
import style0 from "./MbInitiateProcessDefault.vue?vue&type=style&index=0&id=0a3ce90e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ce90e",
  null
  
)

export default component.exports